import React from 'react';

const Features: React.FC = () => {
  const features = [
    {
      icon: '⚡',
      title: 'Facturación Electrónica DIAN',
      description: 'Facturación electrónica certificada oficialmente por DIAN con total cumplimiento normativo colombiano.',
      items: [
        'Generación XML aprobada',
        'Firma digital certificada',
        'Validación en tiempo real',
        'Notas crédito y débito'
      ]
    },
    {
      icon: '🛒',
      title: 'Sistema Punto de Venta (POS)',
      description: 'Flujo completo de ventas con múltiples formatos de impresión y soporte para operaciones de caja.',
      items: [
        'Impresoras térmicas',
        'Múltiples formatos',
        'Cuadre de caja',
        'Métodos de pago variados'
      ]
    },
    {
      icon: '📦',
      title: 'Gestión de Inventario',
      description: 'Control de stock en tiempo real con seguimiento completo de productos y alertas automáticas.',
      items: [
        'Stock en tiempo real',
        'Traslados entre sucursales',
        'Alertas de stock mínimo',
        'Costo promedio ponderado'
      ]
    },
    {
      icon: '👥',
      title: 'Gestión de Clientes',
      description: 'Base de datos completa con listas de precios personalizadas y gestión de crédito.',
      items: [
        'Base de datos completa',
        'Listas de precios por cliente',
        'Gestión de crédito',
        'Historial de transacciones'
      ]
    },
    {
      icon: '💰',
      title: 'Controles Financieros',
      description: 'Cuadre y conciliación de caja con reportes financieros detallados y análisis multi-sucursal.',
      items: [
        'Cuadre de caja',
        'Gestión de egresos',
        'Órdenes de compra',
        'Reportes financieros'
      ]
    },
    {
      icon: '📊',
      title: 'Suite de Reportes',
      description: 'Reportes avanzados de ventas, inventario, finanzas y cumplimiento DIAN exportables a Excel.',
      items: [
        'Reportes de ventas',
        'Reportes DIAN',
        'Análisis financiero',
        'Exportación Excel'
      ]
    }
  ];

  return (
    <section className="features" id="producto">
      <div className="container">
        <div className="section-header">
          <h2>Características Principales</h2>
          <p>Todo lo que necesitas para gestionar tu empresa en una sola plataforma</p>
        </div>
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
              <ul>
                {feature.items.map((item, itemIndex) => (
                  <li key={itemIndex}>{item}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;